module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ZA-4dfea88012748febb49721e43c7f7f17.png";